import { Component, OnInit, ChangeDetectionStrategy, SecurityContext } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogConfig } from '../dialog-config';
import { DialogRef } from '../dialog-ref';

@Component({
    selector: 'app-terms-and-condition-dynamic',
    templateUrl: './terms-and-condition-dynamic.component.html',
    styleUrls: ['./terms-and-condition-dynamic.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsAndConditionDynamicComponent implements OnInit {
  model: any = {};
  containerStyle = '';
  headerStyle = '';
  titleStyle = '';
  contentStyle = '';
  buttonStyle = '';
  logoImg:string = '';
  imgSrc: string = '';
  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    public config: DialogConfig,
    public ref: DialogRef,
    private dom: DomSanitizer,
  ) {
    this.imgSrc = "/assets/images/icon/term-con.svg";
   }


  ngOnInit() {
    //console.log('config',this.config);
    if (this.config.data) {
      this.model = this.config.data;
      this.model.language = this.model.language == 'en' ? 'en' : 'th';
      if (this.model.style) {
        this.containerStyle = this.sanitizeStyle(this.model.style.container);
        this.headerStyle = this.sanitizeStyle(this.model.style.header);
        this.titleStyle = this.sanitizeStyle('font-size: 19px;' + this.model.style.title);
        this.contentStyle = this.sanitizeStyle(this.model.style.content);
        this.buttonStyle = this.sanitizeStyle(this.model.style.button);
      }

      if(this.model.logo_url){
        this.logoImg = '/images/'+ this.model.logo_url;
      }

    }

  }

  private sanitizeStyle(style: string | undefined): string {
    if (style == null || style === '') {
      return '';
    }
    return this.dom.sanitize(SecurityContext.STYLE, style) ?? '';
  }

  clickTab(tab: number) {
    this.model.current = tab;
  }

  onClose(status: boolean = true) {
    this.ref.close(status);
  }

  changeLanguage() {
    if (this.model.language == 'th') {
      this.model.language = 'en'
    } else {
      this.model.language = 'th'
    }
    console.log('this.model', this.model)
  }


}
